module.exports = __webpack_public_path__ + "media/video503.9385b074.mp4";